<template>
<v-card flat>
    <v-card-title>
      <div>
        <h3 class="subheading">Text with buttons response</h3>
        <div class="caption grey--text">{{responsename}}</div>
      </div>
      <v-spacer></v-spacer> 
                <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-xl>
          <v-layout class="scroll-y" style="max-height:250px" row wrap>                        
            <v-flex xs12>
              <v-textarea
                auto-grow
                rows="1"
                label="Message"                
                placeholder="Write the text message here"
                counter="640"
                v-model="text"
              ></v-textarea>                                          
            </v-flex>
            <v-container grid-list-xl>
            <v-layout row fill-height>
            <v-flex v-for="(button,i) in buttons" :key="button.name" xs4>
              <v-switch
                :label="button.label"
                v-model="button.active"
              ></v-switch>
              <v-card flat v-if="button.active">
              <v-select
                  :items="buttontype"
                  label="Button Type"
                  v-model="button.type"
                  item-text="name"
                  item-value="code"
              ></v-select>
              <v-text-field
                v-if="button.type != 'element_share'"
                label="Button Title"
                counter="20"
                v-model="button.title"                
              ></v-text-field>
              <v-text-field
               v-if="button.type == 'web_url'"
                label="Button URL" 
                v-model="button.url"             
              ></v-text-field>
              <v-select
                v-if="button.type == 'web_url'"
                  :items="webviewsizes"
                  label="Web view Size"
                  v-model="button.webview_height_ratio"
                  item-text="name"
                  item-value="code"
              ></v-select>
              <v-text-field
                v-if="button.type == 'phone_number'"
                label="Phone Number"
                placeholder="Like +918886108007" 
                 v-model="button.payload"             
              ></v-text-field>
              <v-select
                  v-if="button.type == 'postback'"
                  label="Link a response"
                  :items="cresponses"
                  v-model="button.response"
                  item-text="name"
                  return-object
              ></v-select> 
              </v-card> 
            </v-flex>
            </v-layout>
            </v-container> 
          </v-layout>                 
        </v-container> 
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer> 
              <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
              <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions> 
        </v-card>
</template>

<script>

export default {
  components:{
   
  },
  data(){
    return{
      text:null,
      buttons:[
        {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
      ],
      buttontype:[{"name":"Link a Response","code":"postback"},{"name":"Weblink","code":"web_url"},{"name":"Phone number","code":"phone_number"}],
      webviewsizes:[{"name":"Compact","code":"compact"},{"name":"Tall","code":"tall"},{"name":"Full","code":"full"}]
    }
  },
  methods:{
    saveCard(){
      let index = this.$store.state.currentResponseIndex
      let message = null
      let cratedButtons = []
      for (let i in this.buttons)
            {
              if (this.buttons[i].active == true)                
              console.log(1)
              {
                if (this.buttons[i].type != null && this.buttons[i].type == "web_url")
                {
                  console.log(2)
                  let button = {"title":this.buttons[i].title,"type":this.buttons[i].type,"url":this.buttons[i].url,"webview_height_ratio":this.buttons[i].webview_height_ratio}
                  cratedButtons.push(button)
                }
                else if(this.buttons[i].type != null && this.buttons[i].type == "phone_number")
                {
                  console.log(3)
                  let button = {"title":this.buttons[i].title,"type":this.buttons[i].type,"payload":this.buttons[i].payload}
                  cratedButtons.push(button)
                }
                else if(this.buttons[i].type != null && this.buttons[i].type == "share")
                {
                  console.log(4)
                  let button = {"type":this.buttons[i].type}
                  cratedButtons.push(button)
                }
                else if(this.buttons[i].type != null && this.buttons[i].type == "postback")
                {
                  console.log(5)
                  let payload = this.buttons[i].response.id
                  let button = {"title":this.buttons[i].title,"type":this.buttons[i].type,"payload":payload}
                  cratedButtons.push(button)
                }
              }
      }
      let buttonTemplate = {
                "attachment":{
                          "type":"template",
                          "payload":{
                                  "template_type":"button",
                                  "text":this.text,
                                  "buttons": cratedButtons
                                  }
                              }
                 }
      message = {"message":buttonTemplate,"type":"button"}                
      this.$store.dispatch('acreateresponseMessage', {index,message})
      this.text = null
      this.buttons =[
        {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
      ]
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    },
    cancelCard(){
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    }
  },
  computed:{
        cresponses(){
            return this.$store.state.responses
        },
        responsename(){
          let index = this.$store.state.currentResponseIndex
          let rname = this.$store.state.responses[index].name
          return rname   
        }
  }
}
</script>
